import React from 'react';

// Define the props interface for your component
interface LoadingSpinnerProps {
  message?: string; // We're making the message prop optional
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-4 space-y-4">
      <div
        className="w-12 h-12 rounded-full animate-spin border-4 border-solid border-[#CBAB6F]"
        style={{ borderTopColor: 'transparent' }}
      ></div>
      {/* Display the message below the spinner */}
      <p className="text-[#CBAB6F] font-semibold">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
